import { render, staticRenderFns } from "./TheButton.vue?vue&type=template&id=2b685264&scoped=true"
import script from "./TheButton.vue?vue&type=script&lang=js"
export * from "./TheButton.vue?vue&type=script&lang=js"
import style0 from "./TheButton.vue?vue&type=style&index=0&id=2b685264&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b685264",
  null
  
)

export default component.exports